<template>
    <MaintenanceChecker
        :checkedParts="[MaintenanceType.sport]"
    >
        <template slot="message">
            <div class="maintenance-mode__offer--terminal">
                <h2>{{ $t('Maintenance in progress')}}</h2>
            </div>
        </template>
        <div
            class="flex w-full sports-page"
        >
            <div
                v-sticky="stickyConfig"
                :class="isSidebarExpanded ? 'is-expanded' : ''"
                class="nav-sidebar"
                id="sports-page"
            >
                <OfferContainer :isFetcher="true">
                    <SidebarContainer />
                </OfferContainer>
            </div>
            <div class="main--terminal">
                <SportsTimeFilterContainer :class="isTimeFilterExpanded ? 'is-expanded' : ''"/>
                <div
                    v-if="false"
                    class="offer__banners"
                >
                    <SimpleBannerContainer
                        :banners="promotionBanners"
                        :bannersShown="2"
                        :type="BannerCategory.promotions "
                        class="banner__container--promo"
                    />
                    <SimpleBannerContainer
                        :banners="quickLinkBanners"
                        :bannersShown="4"
                        :type="BannerCategory.quickLinks"
                        class="banner__container--quick-links"
                    />
                </div>
                <MaintenanceChecker
                    v-if="isOnSportLivePage"
                    :checkedParts="[MaintenanceType.live]"
                >
                    <template slot="message">
                        <div class="maintenance-mode__offer">
                            <Illustration large image="/static/img/illustrations/maintenance__sport.svg"/>
                            <div class="maintenance-mode__offer-copy">
                                {{ $t('Live betting is currently under maintenance') }}
                            </div>
                        </div>
                    </template>
                </MaintenanceChecker>
                <MaintenanceChecker
                    v-if="!isOnSportLivePage"
                    :checkedParts="[MaintenanceType.sport]"
                >
                    <template slot="message">
                        <div class="maintenance-mode__offer">
                            <Illustration large image="/static/img/illustrations/maintenance__sport.svg"/>
                            <div class="maintenance-mode__offer-copy">
                                {{ $t('Part of the offer is unavailable during this maintenance') }}
                            </div>
                        </div>
                    </template>
                </MaintenanceChecker>
                <OfferContainer :isUrlRedirecter="true">
                    <SportsOfferContainer parentModule="ui/sportOffer/sports"/>
                </OfferContainer>
            </div>
            <div class="right-sidebar">
                <BetSlipContainer/>
            </div>
        </div>
    </MaintenanceChecker>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import SidebarContainer from '@src/terminal/app/modules/sportOffer/sidebar/SidebarContainer.vue';
    import SportsOfferContainer from
        '@src/terminal/app/modules/sportOffer/sports/content/SportsOfferContainer.vue';
    import OfferContainer from '@src/terminal/app/modules/sportOffer/OfferContainer.vue';
    import BetSlipContainer from '@src/terminal/app/modules/sportOffer/betslip/BetSlipContainer';
    import SportsTimeFilterContainer from
        '@src/terminal/app/modules/sportOffer/sports/timeFilter/SportsTimeFilterContainer';
    import { MaintenanceType } from '@core/models/country/enums';
    import PromotionPadList from '@src/data/promotionPads'; // replace with real promo pads
    import SimpleBannerContainer from '@app/modules/shared/banners/SimpleBannerContainer.vue';
    import config from '@config';
    import { BannerCategory } from '@core/models/banners/enums';
    import { isEventSolo, isSubNavigationVisible } from 'src/app/layout';
    import { ExpandedEventInUrl } from 'src/app/enums';
    import { setWindowScrollTop } from '@src/app/styles/scripts/uiHelpers';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';
    import { liveTimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';

    export default {
        name: 'SportsPage',
        created() {
            this.stickyConfig = {
                scrollableContentSelector: '.sidebar__responsive__element',
                staticHigherContentSelector: '.sidebar_static__top, .nav-sidebar__wrapper:not(:last-child)',
            };
            // this.fetchPromotionBanners();
            // this.fetchQuickLinkBanners();
        },
        data() {
            return {
                pads: PromotionPadList,
                MaintenanceType,
                BannerCategory,
            };
        },
        beforeDestroy() {
            this.clearSelectedFeaturedItem();
        },
        watch: {
            [`$route.query.${ExpandedEventInUrl.event}`](e) {
                if (isEventSolo() && e) {
                    this.shouldScroolTop = true;
                }
            },
            '$route.params.timeFilter': function (timeFilter) {
                if (isSubNavigationVisible() && timeFilter === liveTimeFilterSlug) {
                    this.closeSidebar();
                }
                this.loadOffer();
            },
        },
        async updated() {
            if (this.shouldScroolTop) {
                this.shouldScroolTop = false;
                await this.$nextTick();
                setWindowScrollTop(0);
            }
        },
        computed: {
            ...mapGetters('data/banners', [
                'promotionBanners',
                'quickLinkBanners',
            ]),
            ...mapGetters('ui/mobile', [
                'isSidebarOpen',
            ]),
            ...mapGetters('ui/sportOffer', [
                'expandedEvent',
            ]),
            ...mapGetters('navigation', [
                'isOnSportLivePage',
            ]),
            // promotion pads should be visible only
            // if there are 2 or more pads available and current page isn't competitions page
            shouldShowBanners() {
                return !this.$route.params.tournamentSlug
                    && this.promotionBanners.length >= config.app.banners.minPromotionBanners
                    && !(isEventSolo() && this.expandedEvent);
            },
            isSubNavigationVisible() {
                return isSubNavigationVisible();
            },
            isSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.sportPrimaryNav);
            },
            isTimeFilterExpanded() {
                return this.isSidebarOpen(SidebarId.sportTimeFilter);
            },
        },
        methods: {
            ...mapActions('ui/sportOffer/sports', [
                'clearSelectedFeaturedItem',
                'loadOffer',
            ]),
            ...mapActions('data/banners', [
                'fetchPromotionBanners',
                'fetchQuickLinkBanners',
            ]),
            ...mapActions('ui/mobile', [
                'closeSidebar',
            ]),
        },
        components: {
            BetSlipContainer,
            SportsOfferContainer,
            OfferContainer,
            SportsTimeFilterContainer,
            SidebarContainer,
            SimpleBannerContainer,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/pages/SportsPageTerminal.vue